import {
  CircleCheckBigIcon,
  FileTextIcon,
  TagIcon,
  TagsIcon,
  UserIcon,
  CarIcon,
} from "lucide-react";

import { AVS_SELLING_TYPE_FLOTTE } from "@/components/backoffice/cat/vehicle-assignment/sales-channels-step";
import {
  filterVisibleVehicleAssignmentDefinitions,
  type VehicleAssignmentFlowContext,
  type VehicleAssignmentStepDefinition,
} from "@/lib/cat/vehicle-assignment-step-definitions";

const avsStepDefinitions: VehicleAssignmentStepDefinition[] = [
  {
    description: "Identification",
    icon: CarIcon,
    id: "vehicle_identification",
    title: "Véhicule",
  },
  {
    description: "Canal de vente",
    icon: TagsIcon,
    id: "sales_channels",
    title: "Canal de vente",
  },
  {
    description: "Particulier/Société",
    icon: UserIcon,
    id: "client",
    title: "Client",
    when: (ctx) => ctx.avsSalesChannel !== AVS_SELLING_TYPE_FLOTTE,
  },
  {
    description: "Informations",
    icon: FileTextIcon,
    id: "additional_informations",
    title: "Informations complémentaires",
  },
  {
    description: "Type de vente",
    icon: TagIcon,
    id: "selling_type_avs",
    title: "Type de vente",
  },
  {
    description: "Récapitulatif & validation CTM",
    icon: CircleCheckBigIcon,
    id: "ctm_summary_validation",
    title: "Récapitulatif & validation CTM",
  },
];

function getAvsVehicleAssignmentVisibleDefinitions(
  ctx: VehicleAssignmentFlowContext,
): VehicleAssignmentStepDefinition[] {
  return filterVisibleVehicleAssignmentDefinitions(avsStepDefinitions, ctx);
}

export { avsStepDefinitions, getAvsVehicleAssignmentVisibleDefinitions };
